function formOptionLabel(options, value) {
  if (value == null || !options?.length) return '';
  const match = options.find((o) => o.value == value);
  return match?.label ? String(match.label).trim().toLowerCase() : '';
}

function isCheckType(ctx) {
  const formData = ctx.formData || {};
  const typeLabel = formOptionLabel(ctx.typeOptions, formData.Type);
  return (
    formData.Type == 8 ||
    ctx.selectedDocument?.typeLabel?.toLowerCase() === 'check' ||
    typeLabel === 'check'
  );
}

function isDropboxSource(ctx) {
  const formData = ctx.formData || {};
  const sourceLabel = formOptionLabel(ctx.sourceOptions, formData.Source);
  return formData.Source == 9 || sourceLabel === 'dropbox';
}

function isDropboxRentCheckDocument(ctx = {}) {
  const title = (ctx.formData?.Title || '').trim();
  if (!/^Rent check for/i.test(title)) return false;
  const groupLabel = formOptionLabel(ctx.groupOptions, ctx.formData?.Group);
  const groupOk = ctx.formData?.Group == 14 || groupLabel === 'rent';
  return isCheckType(ctx) && isDropboxSource(ctx) && groupOk;
}

function isDropboxSecurityDepositCheckDocument(ctx = {}) {
  const title = (ctx.formData?.Title || '').trim();
  if (!/^Security Deposit check for/i.test(title)) return false;
  const groupLabel = formOptionLabel(ctx.groupOptions, ctx.formData?.Group);
  const groupOk =
    ctx.formData?.Group == 31 || groupLabel === 'security deposit';
  return isCheckType(ctx) && isDropboxSource(ctx) && groupOk;
}

function parseCheckPaymentsFromDescription(description) {
  const payments = [];
  if (!description) return payments;
  for (const line of String(description).split(/\n/)) {
    // #check and $amount are independent, so either order on the line is fine.
    const checkNumMatch = line.match(/#([\d-]+)/);
    const amountMatch = line.match(/\$([0-9,]+(?:\.\d+)?)/);
    if (checkNumMatch || amountMatch) {
      payments.push({
        checkNumber: checkNumMatch ? checkNumMatch[1] : '',
        amount: amountMatch ? amountMatch[1].replace(/,/g, '') : '',
      });
    }
  }
  return payments;
}

function descriptionHasAcceptedCheckPayment(description) {
  return parseCheckPaymentsFromDescription(description).some(
    (p) => p.checkNumber && p.amount,
  );
}

function isReadyToAutoReceivePayment(ctx = {}) {
  if (ctx.showReceivePayment) return false;
  if (!ctx.selectedDocument) return false;
  if (
    !isDropboxRentCheckDocument(ctx) &&
    !isDropboxSecurityDepositCheckDocument(ctx)
  ) {
    return false;
  }
  const description = (ctx.formData?.Description || '').trim();
  if (/received payment/i.test(description)) return false;
  return descriptionHasAcceptedCheckPayment(description);
}

function isSecurityDepositCheckTitle(title) {
  return /^Security Deposit check for/i.test(String(title || '').trim());
}

module.exports = {
  parseCheckPaymentsFromDescription,
  descriptionHasAcceptedCheckPayment,
  isDropboxRentCheckDocument,
  isDropboxSecurityDepositCheckDocument,
  isReadyToAutoReceivePayment,
  isSecurityDepositCheckTitle,
};
